var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpaceViewType } from '../enums';
import { StorageService } from '@/infrastructure/utils/util-services/local-storage/type/local-storage-service.interface';
const LOCAL_STORAGE_VIEW_TYPE_KEY = 'LOCAL_STORAGE_VIEW_TYPE_KEY';
let SpaceViewTypeServiceImpl = class SpaceViewTypeServiceImpl {
    constructor(_storageService) {
        this._storageService = _storageService;
    }
    getSpaceViewType() {
        const spaceViewType = this._storageService.getItem(LOCAL_STORAGE_VIEW_TYPE_KEY) || SpaceViewType.GRID;
        return spaceViewType;
    }
    setSpaceViewType(type) {
        this._storageService.setItem(LOCAL_STORAGE_VIEW_TYPE_KEY, type);
    }
};
SpaceViewTypeServiceImpl = __decorate([
    injectable(),
    __param(0, inject(StorageService)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService !== "undefined" && StorageService) === "function" ? _a : Object])
], SpaceViewTypeServiceImpl);
export { SpaceViewTypeServiceImpl };
